import { AI_ASSISTANT_PRIVILEGE } from '@/constants/ai-privileges';
import { ConfigRouteObject } from '@/types';

export const AI_ROUTE: ConfigRouteObject = {
  UI_ICON: ['fal', 'sparkles'],
  UI_LABEL: 'Assistant',
  ROUTE_PATH: 'ai',
  ROUTE_NAME: 'ai.index',
  ROUTE_PARAM: '',
  PRIVILEGES: [AI_ASSISTANT_PRIVILEGE]
};
